import API from './api';

// The users endpoint pages at 10 by default and caps a page at 100. Callers that need everyone
// (the Users page, the case-assignee picker) walk every page rather than silently showing the
// first ten.
export async function fetchAllUsers<T = any>(): Promise<T[]> {
  const out: T[] = [];
  let page = 1;
  for (;;) {
    const res = await API.get(`/api/users?page=${page}&limit=100`);
    out.push(...(res.data.users || []));
    const totalPages = res.data.pagination?.totalPages ?? 1;
    if (page >= totalPages || out.length >= (res.data.pagination?.total ?? out.length)) break;
    page += 1;
  }
  return out;
}
